import React from "react";
import SEO from "../components/SEO";
import legalData from "../data/legal.json";

export default function PrivacyPolicy() {
  return (
    <div className="bg-slate-50">
      <SEO
        title={legalData.privacy?.title}
        description={legalData.privacy?.description}
        ogType="website"
      />
      <section className="section-padding mx-auto w-full max-w-4xl">
        <p className="text-sm uppercase tracking-[0.2em] text-amber-600">
          Privacy Policy
        </p>
        <h1 className="page-title mt-3">
          Manage Your Vastu Privacy Policy
        </h1>
        <div className="card mt-6 space-y-4 p-6 text-sm text-slate-600">
          <p>
            This is a placeholder privacy policy for Manage Your Vastu. Replace
            with legal content before launch.
          </p>
          <p>
            We collect only the information necessary to provide the Manage Your
            Vastu service.
          </p>
        </div>
      </section>
    </div>
  );
}
